import React from "react";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {FormContext} from "../../../../elements/validator/validatedForm/ValidatedForm";
import styles from "./TranscriptRoutingTab.module.css";
import {
    addRoutingDepartment,
    transcriptRoutingDepartmentsSelector,
    TranscriptRoutingSettingsUI
} from "./transcriptRoutingSlice";
import {TranscriptRoutingDepartmentCard} from "./TranscriptRoutingDepartmentCard";

interface TranscriptRoutingDepartmentsProps {
    formContext: FormContext<TranscriptRoutingSettingsUI>;
}

export const TranscriptRoutingDepartments: React.FC<TranscriptRoutingDepartmentsProps> = ({formContext}) => {
    const dispatch = useAppDispatch();
    const departments = useAppSelector(transcriptRoutingDepartmentsSelector);

    return <div className={styles.departmentList}>
        <div className={styles.departmentHeader}>
            <span className={styles.departmentTitle}>Department definitions</span>
            <button
                type="button"
                className={styles.iconActionButton}
                onClick={() => dispatch(addRoutingDepartment())}
                aria-label="Add department"
            >
                <img src="/plusIcon.svg" alt=""/>
            </button>
        </div>
        {departments.map((department, index) =>
            <TranscriptRoutingDepartmentCard
                key={department.id ?? `new-department-${index}`}
                index={index}
                formContext={formContext}
            />
        )}
    </div>;
};
